import React, { ErrorInfo } from "react";
import { useErrorStore } from "../zustand/errors.store";
import { ErrorLogItem } from "../types/errors.interface";

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: Error | null }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state to indicate the error
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const errorLog: ErrorLogItem = {
      errortype: "UI",
      errorname: error.name,
      message: error.message,
      endpoint: null,
      params: null,
    };

    // Log error to Zustand store
    const { addError } = useErrorStore.getState();
    addError(errorLog);
  }

  render() {
    if (this.state.hasError) {
      return <div>Something went wrong.</div>; // Fallback UI
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
